import { Platform } from '@angular/cdk/platform';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy, ViewContainerRef } from '@angular/core';

import { OverlayPosition, ContextMenuController } from '@recruitee/prosemirror';

import { WysiwygComponentPortalService } from '../../component-portal/wysywig-component-portal.service';
import {
  ContextTooltipOverlay,
  ContextTooltipOverlayContainer,
} from '../../directives/context-tooltip-container.directive';
import { ToolbarService } from '../toolbar/toolbar.service';
import { ContextToolbarComponent } from './context-toolbar.component';

@Injectable()
export class ContextToolbarService
  extends WysiwygComponentPortalService<ContextToolbarComponent>
  implements ContextMenuController, OnDestroy {
  constructor(
    overlay: ContextTooltipOverlay,
    vcRef: ViewContainerRef,
    _viewportRuler: ViewportRuler,
    @Inject(DOCUMENT) _document: Document,
    _platform: Platform,
    private overlayContainer: ContextTooltipOverlayContainer,

    private toolbarService: ToolbarService,
  ) {
    super(overlay, vcRef, _viewportRuler, _document, _platform, overlayContainer);
  }

  public open(rect: OverlayPosition) {
    this.openComponent(ContextToolbarComponent, rect, [
      { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' },
      { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' },
    ]);

    if (!this.componentRef) return;

    this.componentRef.instance.buttons$ = this.toolbarService.contextButtons$;
    this.componentRef.changeDetectorRef.detectChanges();
  }

  public close(): void {
    this.componentRef?.destroy();
    this.componentRef = null;
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }

  public ngOnDestroy() {
    this.close();
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public isOpen() {
    return !!this.componentRef;
  }

  public getElement(): HTMLElement | null {
    return this.componentRef?.location.nativeElement || null;
  }
}
